import React from 'react';

const UserPicture = (props) => {
  const { user } = props.auth0;
  return <img width="100px" src={user?.picture} alt="avatar" />;
};

export default UserPicture;
